module.exports = __webpack_public_path__ + "img/33.14c3df24.jpg";